'use client'
import { getProductImages } from 'shared-utils/utils/products'
import { type ICartItemSingle } from 'ecosystem'
import { VStack } from '@chakra-ui/react'
import { blendedUnitPrice, getProductPrice } from 'shared-utils'
import { QuantityDiscountTeaser } from '../../../products/components/QuantityDiscountTeaser'
import { useVatMode } from '../../../common/hooks/useVatMode'
import type { CartItemDetailProps } from './types'
import { CartItemInfo } from './CartItemInfo'

export const CartItemDetailSingle = ({
  cartItem,
  size = 'sm'
}: Omit<CartItemDetailProps, 'cartItem'> & { cartItem: ICartItemSingle }) => {
  const { product } = cartItem.meta.singleType
  const { mainImageUrl } = getProductImages(product.medias)
  const { excludeVat } = useVatMode()

  return (
    <VStack alignItems="stretch" gap={1} w="100%">
      <CartItemInfo
        name={product.name}
        qty={cartItem.qty}
        imgUrl={mainImageUrl}
        // Blended, because the row renders `price × qty`: a PACK line priced in
        // two runs has no single unit price, and showing the undiscounted one
        // would put this row above what `sumCart` contributes for it.
        price={blendedUnitPrice(
          cartItem.qty,
          getProductPrice(product, excludeVat),
          product.quantityDiscount
        )}
        size={size}
      />

      <QuantityDiscountTeaser product={product} quantity={cartItem.qty} surface="cart" />
    </VStack>
  )
}
